import { Component, Injector, Input, Optional, ViewEncapsulation } from '@angular/core';
import { ITableColumn } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { ModalService } from '@lsq-frontend/common-ui';
import { LsqBaseColumnComponent, LsqDataTableComponent } from '@lsq-frontend/common-ui';
import {
    ImageViewableStatus,
    RelationshipInvoice
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { InvoiceHistoricalImagePreviewModal } from '../../invoices/invoices.models';

@Component({
    selector: 'invoice-preview-button-column',
    template: `
        <ng-container [cdkColumnDef]="column.key">
            <th cdk-header-cell *cdkHeaderCellDef></th>
            <td cdk-cell *cdkCellDef="let row; let index = index" [ngStyle]="{ width: '3rem' }">
                <ng-container *ngIf="isViewable(row)">
                    <a
                        class="check-number"
                        href="javascript:void(0)"
                        (click)="handleButtonClick(row)"
                    >
                        <lsq-icon [type]="icons.ImageFile" [width]="14" [height]="18"> </lsq-icon>
                    </a>
                </ng-container>
            </td>
            <td cdk-footer-cell *cdkFooterCellDef></td>
        </ng-container>
    `,
    encapsulation: ViewEncapsulation.None
})
export class InvoicePreviewButtonColumnComponent extends LsqBaseColumnComponent {
    @Input() public column: ITableColumn = {
        key: 'invoiceImage',
        width: '3rem'
    };
    public icons = Icons;

    constructor(public injector: Injector, @Optional() public dataTable: LsqDataTableComponent) {
        super(dataTable);
    }

    public handleButtonClick(invoice: RelationshipInvoice): void {
        if (invoice.imageViewableStatus === ImageViewableStatus.Viewable) {
            const modalService = this.injector.get(ModalService);
            modalService.showModal(new InvoiceHistoricalImagePreviewModal(invoice));
        }
    }

    public isViewable({ imageViewableStatus }: RelationshipInvoice): boolean {
        return imageViewableStatus === ImageViewableStatus.Viewable;
    }
}
